import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import api from "../services/httpClient";
import "../assets/styles/informationLayer.scss";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import AddressLayerData from "../components/Addresses/InformationLayer/AddressLayerData";
import InformationUpdateForms from "../components/Addresses/Edit/InformationUpdateForms";
import InformationUpdateButons from "../components/Addresses/Edit/InformationUpdateButons";
import InformationLayerMap from "../components/InformationLayerMap";
import ChangesHistory from "../components/Addresses/InformationLayer/ChangesHistory";
const Tab = ({ label, activeTab, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`tab ${activeTab === label ? "active" : ""}`}
    >
      {label}
    </div>
  );
};

const InformationLayerUpdate = () => {
  const { addressId } = useParams();
  const [historyRefreshKey, setHistoryRefreshKey] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Warstwa informacyjna");
  const [addressData, setAddressData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formActions, setFormActions] = useState(null);

  const handleResetAction = () => {
    if (typeof formActions?.onReset === "function") {
      formActions.onReset();
    }
  };

  const handleSaveAction = () => {
    if (typeof formActions?.onSave === "function") {
      formActions.onSave();
    }
  };

  useEffect(() => {
    if (location.state?.addressData) {
      setAddressData(location.state.addressData);
    } else if (addressId) {
      const fetchAddressData = async () => {
        setLoading(true);
        try {
          const response = await api.get(`/Address/${addressId}`);
          setAddressData(response.data);
        } catch (err) {
          console.error("Error fetching address data:", err);
          alert("Nie udało się pobrać danych adresu");
          // navigate(`/information/${addressId}`);
        } finally {
          setLoading(false);
        }
      };
      fetchAddressData();
    }
  }, [addressId, location.state, navigate]);

  const renderContent = () => {
    if (loading) return <div>Ładowanie...</div>;
    if (!addressData) return <div>Brak danych do edycji</div>;

    switch (activeTab) {
      case "Warstwa informacyjna":
        return (
          <Row>
            <Col md={12}>
              <AddressLayerData addressData={addressData} />

              <InformationUpdateForms
                addressData={addressData}
                onRegisterActions={setFormActions}
              />
              {formActions && (
                <InformationUpdateButons
                  onReset={handleResetAction}
                  onSave={handleSaveAction}
                  isSaving={formActions.isSaving}
                  isSaveDisabled={formActions.isSaveLocked}
                />
              )}
            </Col>
          </Row>
        );
      case "Historia zmian":
        return (
          <ChangesHistory
            addressData={addressData}
            refreshKey={historyRefreshKey}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="information-layer-container">
      <Container fluid>
        <Row className="mb-4">
          <div>
            <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Warstwa informacyjna
            </h3>
          </div>
        </Row>
        <Row className="mb-4">
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ccc",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tab
                  label="Warstwa informacyjna"
                  activeTab={activeTab}
                  onClick={() => setActiveTab("Warstwa informacyjna")}
                />
                <Tab
                  label="Historia zmian"
                  activeTab={activeTab}
                  onClick={() => setActiveTab("Historia zmian")}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ padding: "20px" }}>{renderContent()}</div>
          </Col>
          <Col className="d-flex">
            {addressData ? (
              <div className="container w-100">
                <InformationLayerMap
                  pins={[{ x: addressData.coordX, y: addressData.coordY }]}
                />
              </div>
            ) : (
              <div
                className="container w-100 d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <Spinner animation="border" />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InformationLayerUpdate;
